import Image from "next/image";
import type { PropsWithChildren } from "react";

import Drawer from "@mui/material/Drawer";
import type { DrawerProps } from "@mui/material";
import IconButton from "@mui/material/IconButton";

import { DisableZoom } from "@/src/component/partial/DisableZoom";

import theme from "@/styles/scss/theme.module.scss";
import styles from "./DrawerWithExit.module.scss";

interface DrawerWithExitProps {
  drawer: DrawerProps;
}

function DrawerWithExit({ children, drawer }: PropsWithChildren<DrawerWithExitProps>) {
  const breakpointKey = `@media (max-width: ${theme.breakpointMDNum}px)`;
  const handleClose = () => {
    if (drawer) {
      //@ts-ignore
      drawer?.onClose(() => {}, "backdropClick");
    }
  };

  return (
    <Drawer
      anchor="bottom"
      PaperProps={{
        sx: {
          width: "100%",
          maxWidth: "100vw",
          background: theme.secondaryMain,
          zIndex: 5000,
          top: "60px",
          borderTopLeftRadius: "20px",
          borderTopRightRadius: "20px",
          [breakpointKey]: {
            minHeight: "105vh !important",
            width: "unset",
            overflowX: "hidden",
            overflowY: "scroll",
          },
        },
      }}
      {...drawer}
    >
      <DisableZoom />
      <div className={styles.drawerHeader}>
        <IconButton onClick={handleClose}>
          <Image
            src={"/image/icon_exit.svg"}
            alt={"Exit Drawer"}
            width={16}
            height={16}
            priority={true}
          />
        </IconButton>
      </div>
      <div className={styles.drawerContent}>{children}</div>
      <div className={styles.drawerFooter}></div>
    </Drawer>
  );
}

export default DrawerWithExit;
